import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchPriceOverrides } from '../utils/priceOverridesApi';
import { setPriceOverrides } from '../utils/priceOverrides';

const PriceOverridesContext = createContext({
  overrides: {},
  loading: true,
  error: null,
  refresh: () => {},
});

export const PriceOverridesProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadOverrides = async () => {
    setLoading(true);
    setError(null);
    try {
      const fetchedOverrides = await fetchPriceOverrides();
      setOverrides(fetchedOverrides);
      setPriceOverrides(fetchedOverrides);
    } catch (err) {
      setError(err?.message || 'Unable to load price overrides.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadOverrides();
  }, []);

  return (
    <PriceOverridesContext.Provider
      value={{
        overrides,
        loading,
        error,
        refresh: loadOverrides,
      }}
    >
      {children}
    </PriceOverridesContext.Provider>
  );
};

export const usePriceOverrides = () => useContext(PriceOverridesContext);
